import React from "react";
import FluidImage from "./fluidImage";

const ResImg = ({ mobile, desktop, critical=false }) => {

  if (mobile?.filename == "" || mobile?.filename == undefined) {
    mobile = desktop;
  }

  return (
    <>
      <div className="hidden lg:block pointer-events-none w-full h-full cover-image">
        <FluidImage image={desktop} className="w-full h-full" critical={critical} />
      </div>

      <div className="lg:hidden pointer-events-none w-full h-full cover-image">
        <FluidImage image={mobile} className="w-full h-full" critical={critical} />
      </div>
    </>
  );
};

export default ResImg;
